import React from "react";
import Home from "./pages/Home";

import "./global/styles.css";

const App: React.FC = () => {
  return <Home />;
};

export default App;
